import React from 'react';
import './index.scss';
import {toJS} from 'mobx';

//api
import {api} from '../../../../functions/api';

//material-ui
import { CircularProgress, Divider, List, ListItem, ListItemText, Checkbox, Chip } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

//custom components
import CustomSnackbar from '../../../../components/global/snackbar';
import Box from '../../../../components/basic/box';
import ChooseCategory from './addCategory';

//other libraries
import { inject, observer } from 'mobx-react';
import SelectSearch from '../../../../components/basic/SelectSearch/SelectSearch'
import Grid from '@material-ui/core/Grid'


const TIMEOUT = 3000;

@inject('internal')
@inject('translate')
@observer
export default class ClientInvisible extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            openSnackbar: false,
            message: "",
            payments: [],
            deliveries: [],
            categories: [],
            categoryDialog: false,
            productList: [],
            invisibleProducts: []
        }
    }

    componentDidMount() {
        if(toJS(this.props.internal.user)
            && toJS(this.props.internal.user.data)
            && toJS(this.props.internal.user.data.permissions)
            && toJS(this.props.internal.user.data.permissions.clients)
            && toJS(this.props.internal.user.data.permissions.clients.invisible)) {

            this.loadClientDetail();
            this.props.internal.setRoute( this.props.routerData.history, this.props.routerData.location.pathname);
        }
        else {
            this.props.internal.pushRoute('/')
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }

    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    turnOffSnackBar = () => {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.setState({
                message: "",
                openSnackbar: false
            })
        }, TIMEOUT)
    }

    available_categories = []
    available_delivery_types = []
    available_payment_types = []
    categories = [];

    loadClientDetail = async () => {
        this.setState({loading: true})
        let load_data = await api({
            method: 'get',
            url: 'clients/' + this.props.routerData.match.params.idClient,
            authorization: this.props.internal.user.access_token,
        })

        if (load_data.success && load_data.success === true) {
            // this.props.internal.setDataForSimpeTable(load_data.data.data)
            this.available_categories = load_data.data.data.available.categories;
            this.available_delivery_types = load_data.data.data.available.delivery_types
            this.available_payment_types = load_data.data.data.available.payment_types


            let checkedPayments = []
            this.available_payment_types.filter(function(data) {
                if(data.available === false) {
                    checkedPayments.push(data.id)
                }
                return false;
            })

            let checkedDeliveries = []
            this.available_delivery_types.filter(function(data) {
                if(data.available === false) {
                    checkedDeliveries.push(data.id)
                }
                return false;
            })

            let checkedCategories = []
            this.available_categories.filter(function(data) {
                if(data.available === false) {
                    checkedCategories.push(data.id)
                }
                return false;
            })
    
            const invisibleProducts = [];
            const productList = load_data.data.data.available.products.map(product => {
                const productItem = {
                    value: product.id,
                    label: product.name
                }
        
                if (false === product.available) {
                    invisibleProducts.push(productItem)
                }
        
                return productItem;
            });


            this.setState({payments: checkedPayments, deliveries: checkedDeliveries, categories: checkedCategories, invisibleProducts, productList})
            this.categories = load_data.data.data.available.categories_structured;
            for(let prop in this.categories) {
                this.categories[prop].level = 0;
                
            }
            
            // this.loadCategories()
        }
        this.setState({loading: false})
    }

    

    loadCategories = async () => {
        this.categories = [];
        this.setState({loading: true})
        let load_data = await api({
            method: 'get',
            url: 'lists/categories',
            authorization: this.props.internal.user.access_token,
        })
        if(load_data.success === true) {
            this.categories = load_data.data.data;
        }

        this.setState({loading: false})
    }

    handleTogglePayments = (value) => () => {
        const { payments } = this.state;
        const currentIndex = payments.indexOf(value);
        const newChecked = [...payments];
    
        if (currentIndex === -1) {
            newChecked.push(value);
        }
        else {
            newChecked.splice(currentIndex, 1);
        }
    
        this.setState({
            payments: newChecked,
        }, ()=> {
            this.updateList()
        });
    };

    handleToggleDeliveries = (value) => () => {
        const { deliveries } = this.state;
        const currentIndex = deliveries.indexOf(value);
        const newChecked = [...deliveries];
    
        if (currentIndex === -1) {
            newChecked.push(value);
        }
        else {
            newChecked.splice(currentIndex, 1);
        }
    
        this.setState({
            deliveries: newChecked,
        }, ()=> {
            this.updateList()
        });
    };

    handleDeleteCategory = (value) => {
        const { categories } = this.state;
        const currentIndex = categories.indexOf(value);
        const newChecked = [...categories];
    
        if (currentIndex === -1) {
            newChecked.push(value);
        }
        else {
            newChecked.splice(currentIndex, 1);
        }
    
        this.setState({
            categories: newChecked,
        }, ()=> {
            this.updateList(true)
        });
        
    }

    handleAddCategory = (data) => {
        const { categories } = this.state;
        const currentIndex = categories.indexOf(data);
        const newChecked = [...categories];
    
        if (currentIndex === -1) {
            newChecked.push(data);
        }
        else {
            newChecked.splice(currentIndex, 1);
        }
    
        this.setState({
            categories: newChecked, categoryDialog: false
        }, ()=> {
            this.updateList(true)
        });
    }
    
    saveInvisibleProducts = () => {
        this.updateList();
    }

    handleChooseCategory = () => {
        this.setState({categoryDialog: !this.state.categoryDialog})
    }

    updateList = async(reload = false) => {
        this.setState({loading: true})
        let idClient = this.props.routerData.match.params.idClient;
        let update_data = await api({
            method: 'patch',
            url: 'clients/' + idClient + "/invisible",
            authorization: this.props.internal.user.access_token,
            params: {
                payment_types: this.state.payments,
                delivery_types: this.state.deliveries,
                categories: this.state.categories,
                products: this.state.invisibleProducts.map(item => item.value),
            }
        })

        if(update_data.success && update_data.success === true) {
            this.setState({message: update_data.data.message, openSnackbar: true})
        }
        else {
            this.setState({message: update_data.data.message, openSnackbar: true})
        }
        this.turnOffSnackBar()
        if(reload) {
            this.loadClientDetail()
        }
        this.setState({loading: false})
    }

    handleCloseCategoryDialog = () => {
        this.setState({categoryDialog: false})
    }

    render() {

        return (
            this.state.loading ?
                <CircularProgress className = {'circular-progress'}/>
            :
                <div className={'clients-invisible-container'}>
                    <CustomSnackbar message={this.state.message} open={this.state.openSnackbar} />
                    {/* {this.state.categoryDialog ?
                        <AddCategoryToInvisible
                            open={this.state.categoryDialog}
                            onClose={this.handleCloseCategoryDialog}
                            title={this.props.translate.i18n.MODULES.CLIENTS.TITLE_ADD_INVISIBLE_CATEGORY}
                            routerData={this.props.routerData}
                            showSnackbar={this.showSnackbar}
                            data={this.available_categories}
                            setCategory={this.handleAddCategory}
                        />
                        :
                        null
                    } */}

                    {this.state.categoryDialog ?
                        <ChooseCategory
                            open={this.state.categoryDialog}
                            onClose={this.handleChooseCategory}
                            title={this.props.translate.i18n.MODULES.CLIENTS.TITLE_ADD_INVISIBLE_CATEGORY}
                            routerData={this.props.routerData}
                            // dialogType={this.state.dialogType}
                            categories={this.categories}
                            setCategory={this.handleAddCategory}
                        />
                        :
                        null
                    }
                    
                    <div className={'box-list'}>
                        <Box>
                            <h2>{this.props.translate.i18n.MODULES.CLIENTS.INVISIBLE_PAYMENTS}</h2>
                            <Divider/>
                            <div className={'list-items'}>
                                <List>
                                    {this.available_payment_types.map((data, index) => {
                                        return(
                                            <ListItem key={data.id}className={'list-item'} onClick={this.handleTogglePayments(data.id)}>
                                                <Checkbox
                                                    checked={this.state.payments.indexOf(data.id) !== -1}
                                                    // checked={data.available}
                                                    tabIndex={-1}
                                                    disableRipple
                                                />
                                                <ListItemText primary={data.name} primaryTypographyProps={{className: 'primary-text'}}/>
                                            </ListItem>
                                            )
                                        }
                                    )}
                                </List>
                            </div>
                        </Box>
                    </div>
                    <div className={'box-list'}>
                        <Box>
                            <h2>{this.props.translate.i18n.MODULES.CLIENTS.INVISIBLE_TRANSPORTS}</h2>
                            <Divider/>
                            <div className={'list-items'}>
                                <List>
                                    {this.available_delivery_types.map((data, index) => {
                                        return(
                                            <ListItem key={data.id} className={'list-item'} onClick={this.handleToggleDeliveries(data.id)}>
                                                <Checkbox
                                                    checked={this.state.deliveries.indexOf(data.id) !== -1}
                                                    tabIndex={-1}
                                                    disableRipple
                                                />
                                                <ListItemText primary={data.name} secondary={data.description} primaryTypographyProps={{className: 'primary-text'}}/>
                                            </ListItem>
                                            )
                                        }
                                    )}
                                </List>
                            </div>
                        </Box>
                    </div>
                    <div className={'box-list'}>
                        <Box>
                            <h2>{this.props.translate.i18n.MODULES.CLIENTS.INVISIBLE_CATEGORIES}</h2>
                            <Divider/>
                            <div className={'list-items'}>
                            {this.available_categories.map((category, index) => {
                                return (
                                    !category.available ?
                                        <Chip
                                            className={'selected-chip'}
                                            key={category.id}
                                            label={category.name}
                                            // onClick={handleClick}
                                            defaultValue={category.id}
                                            onDelete={() => this.handleDeleteCategory(category.id)}
                                        />
                                        :
                                        null
                                );
                            })}
                                <Chip
                                    icon={<AddIcon />}
                                    label={this.props.translate.i18n.GLOBAL.BUTTONS.ADD}
                                    onClick={this.handleChooseCategory}
                                    className={'add-category'}
                                />
                            </div>
                        </Box>
                        <Box>
                            <h2>{this.props.translate.i18n.MODULES.CLIENTS.INVISIBLE_PRODUCTS}</h2>
                            <Divider/>
                            <div className={'p-4'}>
                                <SelectSearch
                                  options={this.state.productList}
                                  // key={`param-${i}`}
                                  onChange={val => this.setState({ invisibleProducts: val })}
                                  value={this.state.invisibleProducts}
                                  isMulti={true}
                                  className={'select-search'}
                                  label={this.props.translate.i18n.MODULES.CLIENTS.INVISIBLE_PRODUCTS}
                                  // menuIsOpen
                                  // onMenuOpen={this.handleScrollDown}
                                />
                            </div>
                            <div className={'p-4'}>
                                <Chip
                                  label={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                                  onClick={this.saveInvisibleProducts}
                                  className={'add-category'}
                                />
                            </div>
                        </Box>
                    </div>
                </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/clients/detail/invisible/index.js